import CompleteComponent from "../components/CompleteComponent";
import useComplete from "../hook/useComplete";
import useProduct from "../hook/useProduct";


const CompletePage = ({

}) => {
    const complete = useComplete();
    const footerMenu = useProduct();
    return <CompleteComponent {...complete} {...footerMenu} />
}
export default CompletePage;